<div class="dialog-title-row" fxLayout="row" fxLayoutAlign="space-between center">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <button mat-icon-button class="close-button" (click)="close()" aria-label="Fechar">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="dialog-content">
  <mat-card class="p-0 popup-wrapper">
    <form [formGroup]="movtoForm">
      <div class="filters-row" fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="8px">
        <div fxFlex="20" fxFlex.lt-sm="100">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Data Inicial</mat-label>
            <input matInput name="dataInicial" type="date" [(ngModel)]="dataInicial" [ngModelOptions]="{standalone: true}" (change)="reloadPageMovto()">
          </mat-form-field>
        </div>
        <div fxFlex="20" fxFlex.lt-sm="100">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Data Final</mat-label>
            <input matInput name="dataFinal" type="date" [(ngModel)]="dataFinal" [ngModelOptions]="{standalone: true}" (change)="reloadPageMovto()">
          </mat-form-field>
        </div>
        <div fxFlex="25" fxFlex.lt-sm="100">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Ordenar por</mat-label>
            <mat-select [(value)]="selectedOrdem" (selectionChange)="reloadPageMovto()">
              <mat-option value="NENHUM">Controle</mat-option>
              <mat-option value="TRANSACAO">Transação</mat-option>
              <mat-option value="EMISSAO">Emissão</mat-option>
              <mat-option value="ENTRADA">Entrada/Saída</mat-option>
              <mat-option value="VALOR">Total Docto</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="25" fxFlex.lt-sm="100">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Direção</mat-label>
            <mat-select [(value)]="selectedDirect" (selectionChange)="reloadPageMovto()">
              <mat-option value="ASC">Menor para maior</mat-option>
              <mat-option value="DESC">Maior para menor</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="8" fxFlex.lt-sm="100" class="refresh-wrap">
          <button mat-raised-button color="primary" class="refresh-btn" (click)="$event.preventDefault(); reloadPageMovto()">
            <mat-icon>refresh</mat-icon>
            <span *ngIf="layoutConf?.isMobile">Atualizar</span>
          </button>
        </div>
      </div>

      <ng-container *ngIf="layoutConf?.isMobile; else desktopMovtoTable">
        <div class="mobile-cards-wrap" *ngIf="movtos?.length; else emptyMovtoList">
          <mat-card class="mobile-card" *ngFor="let row of movtos; let i = index">
            <div class="mobile-card-header">
              <div class="mobile-card-title">#{{ i + 1 }} - {{ (row?.controle ?? 0).toString().padStart(10, '0') }}</div>
              <span class="mobile-card-status">{{ row?.statuslcto || '-' }}</span>
            </div>

            <div class="mobile-card-grid">
              <div><span>Emissão</span><strong>{{ row?.emissao | date:'dd/MM/yyyy' }}</strong></div>
              <div><span>Entrada/Saída</span><strong>{{ row?.dataentradasaida | date:'dd/MM/yyyy' }}</strong></div>
              <div><span>Número</span><strong>{{ (row?.numeroDocto ?? 0).toString().padStart(9, '0') }}</strong></div>
              <div><span>Natureza</span><strong>{{ row?.serieNatureza || '-' }}</strong></div>
              <div><span>Total</span><strong>{{ row?.valortotalDocto | currency:'BRL' }}</strong></div>
              <div><span>Empresa</span><strong>{{ (row?.filialId ?? '').toString().padStart(3, '0') + '-' + (row?.filialNomeFantasia || '') }}</strong></div>
            </div>

            <div class="mobile-card-line">
              <span>Transação</span>
              <strong>{{ (row?.fatTransacaoCodigo ?? '').toString().padStart(5, '0') + '-' + (row?.fatTransacaoDescricao || '') }}</strong>
            </div>
          </mat-card>
        </div>

        <mat-paginator
          class="mobile-paginator"
          #paginator
          [length]="length"
          [showFirstLastButtons]="true"
          [pageSize]="pageSize"
          [pageSizeOptions]="pageSizeOptions"
          (page)="pageEvent = setPageSizeOptions($event)">
        </mat-paginator>
      </ng-container>

      <ng-template #desktopMovtoTable>
        <ngx-datatable class="material ml-0 mr-0" [rows]="movtos" [headerHeight]="50" [footerHeight]="50"
          [scrollbarH]="true" [messages]="{emptyMessage:'Nenhuma movimentação encontrada p/ o período'}"
          [limit]="pageSize" [rowHeight]="50">
          <ngx-datatable-column name="#" [width]="25">
            <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
              <strong>{{ rowIndex+1 }}</strong>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="C.S." [flexGrow]="1" [width]="90">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row?.statuslcto }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Controle" [flexGrow]="1" [width]="120">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{row?.controle.toString().padStart(10, '0')}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Emissão" [flexGrow]="1" [width]="120">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row?.emissao | date:'dd/MM/yyyy' }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Entrada/Saída" [flexGrow]="1" [width]="120">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row?.dataentradasaida | date:'dd/MM/yyyy' }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Natureza" [flexGrow]="1" [width]="90">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row?.serieNatureza }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Número" [flexGrow]="1" [width]="120">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{row?.numeroDocto.toString().padStart(9, '0')}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Transação" [flexGrow]="1" [width]="250" headerClass="text-right">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ (row?.fatTransacaoCodigo??'').toString().padStart(5, '0') +'-'+ row?.fatTransacaoDescricao }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Total" [flexGrow]="1" [width]="120">
            <ng-template ngx-datatable-header-template let-column="column">
              <div style="text-align:right">
                <span title="Total do Lançamento">Total</span>
              </div>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div style="text-align:right">
                {{ row?.valortotalDocto | currency: 'BRL' }}
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Empresa" [flexGrow]="1" [width]="250">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ (row?.filialId??'').toString().padStart(3, '0') +'-'+ row?.filialNomeFantasia }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
              <mat-paginator #paginator [length]="length" fxLayoutAlign="space-around center"
                [showFirstLastButtons]="true" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                (page)="pageEvent = setPageSizeOptions($event)">
              </mat-paginator>
            </ng-template>
          </ngx-datatable-footer>
        </ngx-datatable>
      </ng-template>

      <ng-template #emptyMovtoList>
        <div class="empty-state">Nenhuma movimentação encontrada para o período.</div>
      </ng-template>
    </form>
  </mat-card>
</div>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button color="warn" type="button" (click)="close()">
    <mat-icon>close</mat-icon>{{"CLOSE" | translate }}
  </button>
</mat-dialog-actions>